import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Nova Categoria de Link", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Nome Categoria ", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Salvar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name"
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name"
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.note) = $event)),
          class: "form-control",
          name: "note"
        }, null, 512), [
          [_vModelText, $setup.data.note]
        ])
      ]),
      _hoisted_8
    ], 32)
  ]))
}